import React, { useEffect, useState } from 'react';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { useLoading } from '../../commons/Loading';
import { Link, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Footer from '../../commons/Footer';
import { Card, CardBody, Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import {
  BtnRadiusWhite,
  ContFlexLeft,
  H4Styled,
} from '../../styled-components';
import { ReactComponent as IconBack } from '../../images/icn-back.svg';
import classNames from 'classnames';
import variables from '../../variables';
import './CondoDetail.scss';
import './TabsProfile.scss';
import axios from 'axios';
import CondoDocuments from './CondoDocuments';
import { NumberParam, StringParam, withDefault } from 'serialize-query-params';
import { useQueryParams } from 'use-query-params';
import CondoFinancialReports from './CondoFinancialReports';
import CondoBalances from './CondoBalances';
const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

function EonCondosDetail(props) {
  const [
    { newToken, newIsAdmin, newUserType = '', profile = {} } = {},
  ] = useAuth();
  const [t] = useTranslation('CONDOS_DETAIL');
  const [pageBack, setPageBack] = useState('');
  const alert = useAlert();
  const { showLoading, hideLoading } = useLoading();
  const { history, location, match = {} } = props;
  const { params: { id } = {}, url = '' } = match;
  const { pathname = '', state = {} } = location;
  const tab = pathname.split('/').pop();

  const [condo, setCondo] = useState({});

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    active: withDefault(StringParam, localStorage.getItem('active')),
  });

  const { limit, offset, active } = query;

  function onFilter(queryDiff) {
    if (
      (queryDiff.active && queryDiff.active !== active) ||
      (active && queryDiff.active === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0;
    }
    setQuery(queryDiff);
  }

  const fetchCondo = async () => {
    if (tab === 'info') {
      showLoading();
    }
    const response = await axios({
      method: 'get',
      url: `${process.env.REACT_APP_API_URL}/condos/detail/${id}`,
      headers: {
        Authorization: newToken,
      },
    });

    if (response instanceof Error) {
      hideLoading();

      alert.error(t('COMMON:GENERIC_ERROR'));
      return;
    }

    if (tab === 'info') {
      hideLoading();
    }

    const { data = [] } = response;
    setCondo(data);
  };

  useEffect(() => {
    fetchCondo();
  }, []);

  useEffect(() => {
    if (state.pageBack) setPageBack(state.pageBack);
  }, [state]);

  if (pathname === url) {
    return <Redirect to={`${url}/balances`} />;
  }

  return (
    <div>
      <Row>
        <Col sm="12" md="6">
          <ContFlexLeft>
            <BtnRadiusWhite
              onClick={() => {
                history.replace(`/my-eon-condos`);
              }}
            >
              <IconBack fill={variables.primary} />
            </BtnRadiusWhite>
            <H4Styled>{condo.name}</H4Styled>
          </ContFlexLeft>
        </Col>
      </Row>

      <div className="m-tb-20">
        <Nav tabs>
          <NavItem>
            <NavLink
              tag={Link}
              to={`${match.url}/balances`}
              className={classNames({ active: tab === 'balances' })}
            >
              {t('TABS:CONDO_BALANCES')}
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              tag={Link}
              to={`${match.url}/condo-documents`}
              className={classNames({ active: tab === 'condo-documents' })}
            >
              {t('TABS:CONDO_DOCUMENTS')}
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink
              tag={Link}
              to={`${match.url}/financial-reports`}
              className={classNames({
                active: [
                  'financial-reports',
                  'variable-revenues',
                  'variable-revenues-insurances',
                  'variable-revenues-energy',
                  'variable-revenues-recurrent-energy',
                ].includes(tab),
              })}
            >
              {t('TABS:FINANCIAL_REPORTS')}
            </NavLink>
          </NavItem>
        </Nav>

        <Switch>
          <Route
            path={`${match.url}/balances`}
            component={(props) => (
              <Card>
                <CardBody>
                  <CondoBalances profile={profile} condoId={id}></CondoBalances>
                </CardBody>
              </Card>
            )}
          />

          <Route
            path={`${match.url}/condo-documents`}
            component={(props) => (
              <Card>
                <CardBody>
                  <CondoDocuments
                    profile={profile}
                    condo={condo}
                    query={query}
                    onFilter={onFilter}
                  ></CondoDocuments>
                </CardBody>
              </Card>
            )}
          />

          <Route
            path={`${match.url}/financial-reports`}
            component={(props) => (
              <Card>
                <CardBody>
                  <CondoFinancialReports
                    profile={profile}
                    id={id}
                    data={condo}
                    match={match}
                  ></CondoFinancialReports>
                </CardBody>
              </Card>
            )}
          />
        </Switch>
      </div>
      <Footer />
    </div>
  );
}

export default EonCondosDetail;
